import React, { useState } from "react";
import { useQuery } from "react-query";
import { Navigate, useParams } from "react-router-dom";
import userServices from "../../services/users";
import DSpinner from "../../components/DSpinner";
import DCard from "../../components/DCard";
import DTable from "../../components/Table/index";
import { orderStatusBtnStyle, statusMessage } from "../../utils/functions";
import moment from "moment";
import DButton from "../../components/DButton";
import PageHeading from "../../components/PageHeading";

const columns = [
  { Header: "رقم الطلب", accessor: "id" },
  // { Header: "معرف المنتج", accessor: "subitem_id" },
  { Header: "المنتج الفرعي", accessor: "name" },
  { Header: "معرف اللاعب", accessor: "playerid" },
  { Header: "السعر", accessor: "total_cost" },
  { Header: "الكمية", accessor: "amount" },
  { Header: "المعرف الخارجي", accessor: "external_id" },
  { Header: "نوع المعاملة", accessor: "type" },
  { Header: "تاريخ الطلب", accessor: "created_at" },
  { Header: "ملاحظات", accessor: "note" },
  { Header: "حالة الطلب", accessor: "status" },
];
const Orders = ({ title }) => {
  const { id } = useParams();
  const [currentPage, setCurrentPage] = useState(0);
  const { data, isLoading, error } = useQuery(
    ["getUserOrders", id, currentPage],
    () => userServices.getUserOrders(id, currentPage + 1),
    {
      retry: false,
    }
  );
  if (error) {
    return <Navigate to="/404" />;
  }
  const formattedData = (data) => {
    if (data.length > 0) {
      return data.map((d) => ({
        ...d,
        name: d.subitem.name,
        // subitem_id: d.subitem.id,
        external_id: d.external_id ? d.external_id : "لايوجد",
        status: statusMessage(d.status),
        created_at: moment(d.created_at).format("hh:mm:ss YYYY-MM-DD"),
        playerid: d.order_info.player_id,
        type: d.subitem.api_id ? "آلي" : "يدوي",
      }));
    }
    return [];
  };
  const statusSorrundWithButton = (cell) => {
    return (
      <DButton
        className={`${
          cell.value === "في الانتظار" ? "text-third-color" : "text-white"
        } min-w-[100px] rounded-[50px_!important]`}
        bgColor={orderStatusBtnStyle(cell.value)}
      >
        {cell.render("Cell")}
      </DButton>
    );
  };
  return (
    <div className="orders">
      <PageHeading>{title}</PageHeading>
      <DCard className={`relative ${isLoading ? "min-h-[400px]" : ""}`}>
        {" "}
        {isLoading ? (
          <DSpinner />
        ) : (
          <DTable
            totalData={data.data.data.total}
            body={formattedData(data.data.data.data)}
            head={columns}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            elements={{ status: statusSorrundWithButton }}
          />
        )}
      </DCard>
    </div>
  );
};
export default Orders;
